import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

export default function RequestLoading({message = "Loading..."}) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <Stack
                alignItems="center"
                spacing={3}
            >
                <>
                    <CircularProgress />
                    <Typography variant="h6" sx={{ color: "#5261AC" }}>
                        {message}
                    </Typography>
                </>
            </Stack>
        </Box>
    )
}